var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx } from "react/jsx-runtime";
import { getMonthStart, getYear } from '@wojtekmaj/date-utils';
import TileGroup from '../TileGroup.js';
import Month from './Month.js';
export default function Months(props) {
  var activeStartDate = props.activeStartDate,
      hover = props.hover,
      value = props.value,
      valueType = props.valueType,
      otherProps = __rest(props, ["activeStartDate", "hover", "value", "valueType"]);

  var start = 0;
  var end = 11;
  var year = getYear(activeStartDate);
  return _jsx(TileGroup, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      var date = new Date();
      date.setFullYear(year, monthIndex, 1);
      return getMonthStart(date);
    },
    dateType: "month",
    end: end,
    hover: hover,
    renderTile: function renderTile(_a) {
      var date = _a.date,
          otherTileProps = __rest(_a, ["date"]);

      return _jsx(Month, __assign({}, otherProps, otherTileProps, {
        activeStartDate: activeStartDate,
        date: date
      }), date.getTime());
    },
    start: start,
    value: value,
    valueType: valueType
  });
}